export const Signal = {
    Pnr: 'pnr',
    Booking: 'booking',
    TotalPrice: 'total_price',
    History: 'history',
    Address: 'address',
    Feedback: 'feedback',
    CustomerPerson: 'customer_person',
    CancelQuery: 'cancel_query'
}